module.exports = __webpack_public_path__ + "static/share-88f3225529d59677c8d8344e48aafd84.jpg";